export function isInstrumentIntradayCapable(positionSet, instrumentsWithQueryOptions, instrumentsMetadata) {
  if (positionSet === instrumentsWithQueryOptions?.original) return !!instrumentsMetadata?.original?.intradayEnabled
  if (positionSet === instrumentsWithQueryOptions?.rebalanced) return !!instrumentsMetadata?.rebalanced?.intradayEnabled
  if (positionSet === instrumentsWithQueryOptions?.comparison) return !!instrumentsMetadata?.comparison?.intradayEnabled
  return false
}
